import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
import { getCookie, setCookie, removeCookie } from '../../utils';
const gdprCookie = 'gdpr-cookie-consent';
const gdprUserCookie = 'gdpr-user';
const optOutCookie = 'opt-out';
const gdprAcceptedValue = 'accepted';
const gdprNotAcceptedValue = 'not-accepted';
const gdprUserValue = 'true';
const optOutValue = 'opt-out';
const cookieExpiryInDays = 365;
const CookiePreferencesContext = createContext({
    hasGdprConsented: false,
    isGdprUser: true,
    hasOptedOut: true,
    setGdprConsent: () => {
        throw new Error('Missing Provider');
    }
});
export const useCookiePreferences = () => {
    return useContext(CookiePreferencesContext);
};
export const CookiePreferencesProvider = ({ children }) => {
    const [hasGdprConsented, setHasGdprConsented] = useState(getCookie(gdprCookie) === gdprAcceptedValue);
    const [hasOptedOut, setHasOptedOut] = useState(getCookie(optOutCookie) === optOutValue);
    const [isGdprUser] = useState(getCookie(gdprUserCookie) === gdprUserValue);
    const setGdprConsent = (accepted) => {
        if (accepted) {
            removeCookie(optOutCookie);
            setCookie(gdprCookie, gdprAcceptedValue, cookieExpiryInDays);
        }
        else {
            setCookie(optOutCookie, optOutValue, cookieExpiryInDays);
            setCookie(gdprCookie, gdprNotAcceptedValue, cookieExpiryInDays);
        }
        setHasOptedOut(getCookie(optOutCookie) === optOutValue);
        setHasGdprConsented(getCookie(gdprCookie) === gdprAcceptedValue);
    };
    return (_jsx(CookiePreferencesContext.Provider, Object.assign({ value: {
            hasGdprConsented,
            isGdprUser,
            hasOptedOut,
            setGdprConsent
        } }, { children: children }), void 0));
};
export const StaticCookiePreferencesProvider = ({ gdprConsent, gdprUser, optOut, children }) => {
    const [hasGdprConsented] = useState(gdprConsent === gdprAcceptedValue);
    const [isGdprUser] = useState(gdprUser === gdprUserValue);
    const [hasOptedOut] = useState(optOut === optOutValue);
    const setGdprConsent = () => {
        throw new Error('Not for use on static provider');
    };
    return (_jsx(CookiePreferencesContext.Provider, Object.assign({ value: { hasGdprConsented, isGdprUser, hasOptedOut, setGdprConsent } }, { children: children }), void 0));
};
//# sourceMappingURL=use-cookie-preferences.js.map